import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import { useNavigate } from "react-router-dom";
import { CheckIcon, ChevronRightIcon, CloseIcon, CogIcon } from "../../../constants/Icons";

const ModeModal = ({ onClose, onConfirm }) => {
  const showAlert = useShowAlert();
  const navigate = useNavigate();
  const { viewOptionSecondLevel } = usePermission();
  const [selectedOption, setSelectedOption] = useState(null);
  const options = [
    ...(viewOptionSecondLevel("saleSettings", "saleModeSettings", "isBill")
      ? ["BILL"]
      : []),
    ...(viewOptionSecondLevel("saleSettings", "saleModeSettings", "isInvoice")
      ? ["INVOICE"]
      : []),
  ];
  //   const options =[
  //     "BILL",
  //     "INVOICE"
  //   ]
  const isSaleModeDisabled = options.length === 0;
  const containerRef = useRef(null);

  const handleRadioChange = (option) => {
    setSelectedOption(option);
  };

  const handleConfirm = () => {
    if (!selectedOption) {
      showAlert("warning", Messages.ERROR.MODE_EMPTY);
      return false;
    }
    onConfirm(selectedOption);
    onClose();
  };

  const handleKeyDown = (e) => {
    const currentIndex = options.indexOf(selectedOption);
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % options.length;
      setSelectedOption(options[nextIndex]);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const prevIndex = (currentIndex - 1 + options.length) % options.length;
      setSelectedOption(options[prevIndex]);
    } else if (e.key === "Enter") {
      handleConfirm();
    }
  };

  useEffect(() => {
    containerRef.current?.focus(); // focus to listen to keyboard
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="ModeModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div
            className="modal-content"
            ref={containerRef}
            tabIndex={-1}
            onKeyDown={handleKeyDown}
          >
            <div className="modal-header">
              <h6 className="modal-title"> Are you want to generate? </h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="model-body">
              {isSaleModeDisabled ? (
                <div className="alert alert-warning m-3 mb-0">
                  <div className="fw-semibold mb-1">
                    Sale cannot be processed.
                  </div>
                  <div>
                    Please go to <strong>Settings → Sale → Sale Mode</strong>{" "}
                    and enable at least one sale mode (Bill or Invoice) to
                    continue.
                  </div>
                </div>
              ) : (
                <div className="row mx-2">
                  {/* Existing Bill & Invoice options */}
                </div>
              )}
              <div className="row mx-2">
                <div className="col-12  mb-2">
                  {viewOptionSecondLevel(
                    "saleSettings",
                    "saleModeSettings",
                    "isBill",
                  ) && (
                    <div
                      className={`form-check form-chexk-input-tax-model  custom-option custom-option-basic ${
                        selectedOption === "BILL" ? "checked" : ""
                      }`}
                      autoFocus
                    >
                      <label
                        class="form-check-label custom-option-content"
                        for="customRadioIcon1"
                      >
                        <input
                          name="customRadioIcon-01"
                          className="form-check-input fs-6"
                          type="radio"
                          id="customRadioIcon1"
                          checked={selectedOption === "BILL"}
                          onChange={() => handleRadioChange("BILL")}
                        />
                        <span class="custom-option-header">
                          <span class="h6 mb-0 radioText">Bill Receipt </span>
                          <span className="radioText">
                            <ChevronRightIcon iClass={"fs-6"}/>
                          </span>
                        </span>
                      </label>
                    </div>
                  )}
                </div>
                <div class="col-12">
                  {viewOptionSecondLevel(
                    "saleSettings",
                    "saleModeSettings",
                    "isInvoice",
                  ) && (
                    <div
                      className={`form-check  form-chexk-input-tax-model custom-option custom-option-basic ${
                        selectedOption === "INVOICE" ? "checked" : ""
                      }`}
                      autoFocus
                    >
                      <label
                        class="form-check-label custom-option-content"
                        for="customRadioIcon2"
                      >
                        <input
                          name="customRadioIcon-01"
                          className="form-check-input fs-6"
                          type="radio"
                          id="customRadioIcon2"
                          checked={selectedOption === "INVOICE"}
                          onChange={() => handleRadioChange("INVOICE")}
                        />
                        <span class="custom-option-header">
                          {" "}
                          <span class="h6 mb-0 radioText">
                            Tax Invoice{" "}
                          </span>{" "}
                          <span className="radioText">
                          <ChevronRightIcon iClass={"fs-6"}/>
                          </span>{" "}
                        </span>
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="modal-body">
              <div className="col g-2">
                {viewOptionSecondLevel(
                  "saleSettings",
                  "saleModeSettings",
                  "isBill"
                ) && (
                  <div className="col-md mb-md-0 mb-5">
                    <div
                      className={`form-check   custom-option-icon ${
                        selectedOption === "BILL" ? "checked" : ""
                      }`}
                      autoFocus
                    >
                      <label
                        className="form-check-label custom-option-content p-1"
                        htmlFor="customRadioIcon1"
                      >
                        <span className="custom-option-body">
                          <i className="icon-base bx bx-file mb-2 fs-6"></i>
                          <span className="custom-option-title mb-2 fs-6">
                            {" "}
                            Bill Receipt{" "}
                          </span>
                        </span>
                        <input
                          name="customRadioIcon-01"
                          className="form-check-input fs-6"
                          type="radio"
                          id="customRadioIcon1"
                          checked={selectedOption === "BILL"}
                          onChange={() => handleRadioChange("BILL")}
                        />
                      </label>
                    </div>
                  </div>
                )}
                {viewOptionSecondLevel(
                  "saleSettings",
                  "saleModeSettings",
                  "isInvoice"
                ) && (
                  <div className="col-md  mb-md-0 mb-5">
                    <div
                      className={`form-check  custom-option-icon ${
                        selectedOption === "INVOICE" ? "checked" : ""
                      }`}
                      autoFocus
                    >
                      <label
                        className="form-check-label  custom-option-content p-1"
                        htmlFor="customRadioIcon2"
                      >
                        <span className=" custom-option-body">
                          <i className="icon-base bx bx-receipt mb-2 fs-6"></i>
                          <span className="custom-option-title mb-2 fs-6">
                            {" "}
                            Tax Invoice{" "}
                          </span>
                        </span>
                        <input
                          name="customRadioIcon-01"
                          className="form-check-input fs-6"
                          type="radio"
                          id="customRadioIcon2"
                          checked={selectedOption === "INVOICE"}
                          onChange={() => handleRadioChange("INVOICE")}
                        />
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div> */}

            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              {isSaleModeDisabled ? (
                <button
                  type="button"
                  className="btn btn-primary ms-2 text-right"
                  onClick={() => {
                    onClose();
                    navigate("/setting");
                  }}
                >
                  <CogIcon/> Go to Settings
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary ms-2 text-right"
                  onClick={handleConfirm}
                >
                  <CheckIcon/> Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeModal;
